import React, { useEffect, useState } from "react";
import { getData } from "../../../../services/library";
import { useLocation, useNavigate } from "react-router-dom";

// MUI components
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Divider from "@mui/material/Divider";
import Grid from "@mui/material/Grid";
import Chip from "@mui/material/Chip";
import WarningIcon from "@mui/icons-material/Warning";
import CircularProgress from "@mui/material/CircularProgress";

function VerFacturaEnvasado() {
  const location = useLocation();
  const navigate = useNavigate();
  const [factura, setFactura] = useState(null);
  const [notaCredito, setNotaCredito] = useState(null);
  const [loadingNC, setLoadingNC] = useState(false);

  const onBack = () => navigate(-1);

  const obtenerFactura = () => {
    getData("/envasado_pedidos/verfactura/" + location.state.id, (data) => {
      if (Array.isArray(data) && data.length > 0) {
        setFactura(data[0]);
      }
    });
  };  

  const obtenerNotaCredito = () => {
    getData("/envasado_pedidos/verNC/"+factura.uuid, (data) => {
      if (Array.isArray(data) && data.length > 0) {
        setNotaCredito(data[0]);
      }
    });
  };  

  useEffect(() => {
    if (factura !== null ) {
      if (location.state.estado===328) {
        obtenerNotaCredito()
      }
    }else{
      console.log("no hay nota");
      
    }
  }, [factura])  
  
  useEffect(() => {
    obtenerFactura();
  }, []);

  if (!factura) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
        <CircularProgress />
      </Box>
    );
  }

  const productos = location.state.producto.split("--").map(p => p.trim()).filter(p => p);
  const isAnulada = location.state.estado === 328;
  const colorPrincipal = isAnulada ? "#D32F2F" : "#2471A3"; // Rojo para anuladas, azul original para las demás
  const colorSecundario = isAnulada ? "#FFCDD2" : "#EAF2F8"; // Rojo claro para fondos

  return (
    <Box sx={{ backgroundColor: "#f5f7fa", minHeight: "100vh" }}>
      <AppBar position="relative" sx={{ 
        bgcolor: colorPrincipal, 
        boxShadow: "none",
        transition: 'background-color 0.3s ease'
      }}>
        <Toolbar>
          <IconButton edge="start" color="inherit" onClick={onBack} aria-label="close">
            <CloseIcon />
          </IconButton>
          <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
            {isAnulada ? "Factura Anulada" : "Factura"} #{location.state.id}
          </Typography>
          <Chip 
            label={isAnulada ? "Anulada" : (factura.estado || "Completada")} 
            color={isAnulada ? "error" : "success"} 
            variant="outlined"
            sx={{ 
              color: "white", 
              borderColor: "white",
              fontWeight: 'bold'
            }}
            icon={isAnulada ? <WarningIcon /> : undefined}
          />
        </Toolbar>
      </AppBar>

      {/* Contenido principal */}
      <Box sx={{ p: 1 }}>
        {/* Sección de Nota de Crédito si está anulada */}
        {isAnulada && (
          <Paper sx={{ 
            p: 3, 
            mb: 3, 
            borderRadius: 2, 
            boxShadow: 2,
            backgroundColor: colorSecundario,
            borderLeft: `4px solid ${colorPrincipal}`
          }}>
            <Typography variant="h6" gutterBottom sx={{ 
              color: colorPrincipal, 
              borderBottom: `2px solid ${colorPrincipal}`, 
              pb: 1,
              display: 'flex',
              alignItems: 'center'
            }}>
              <WarningIcon sx={{ mr: 1, color: colorPrincipal }} />
              Nota de Crédito Asociada
            </Typography>
            
            {loadingNC ? (
              <Box display="flex" justifyContent="center" alignItems="center">
                <CircularProgress size={24} sx={{ mr: 2 }} />
                <Typography>Cargando nota de crédito...</Typography>
              </Box>
            ) : notaCredito ? (
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6} md={4}>
                  <Typography variant="subtitle2" sx={{ fontWeight: 'bold', color: colorPrincipal }}>
                    Número NC
                  </Typography>
                  <Typography>{notaCredito.nro_comprobante}</Typography>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <Typography variant="subtitle2" sx={{ fontWeight: 'bold', color: colorPrincipal }}>
                    Fecha Emisión
                  </Typography>
                  <Typography>{notaCredito.fecha_emision}</Typography>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <Typography variant="subtitle2" sx={{ fontWeight: 'bold', color: colorPrincipal }}>
                    Factura Asociada
                  </Typography>
                  <Typography>#{notaCredito.nro_comprobante_asociado}</Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography variant="subtitle2" sx={{ fontWeight: 'bold', color: colorPrincipal }}>
                    Importe Total
                  </Typography>
                  <Typography variant="h6" sx={{ color: colorPrincipal, fontWeight: 'bold' }}>
                    ${notaCredito.importe_total.toLocaleString()}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography variant="subtitle2" sx={{ fontWeight: 'bold', color: colorPrincipal }}>
                    CAE
                  </Typography>
                  <Typography>{notaCredito.cae}</Typography>
                </Grid>
              </Grid>
            ) : (
              <Typography color="error">No se encontró la nota de crédito asociada</Typography>
            )}
          </Paper>
        )}

        {/* Encabezado */}
        <Paper sx={{ 
          p: 3, 
          mb: 3, 
          borderRadius: 2, 
          boxShadow: 2,
          borderLeft: `4px solid ${colorPrincipal}`
        }}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Typography variant="h5" gutterBottom sx={{ 
                color: colorPrincipal, 
                fontWeight: 'bold' 
              }}>
                {factura.empresa}
                {isAnulada && (
                  <WarningIcon sx={{ 
                    ml: 1, 
                    color: colorPrincipal,
                    verticalAlign: 'middle'
                  }} />
                )}
              </Typography>
              <Typography variant="body2" color="textSecondary">
                Punto de Venta: {factura.pto_venta}
              </Typography>
              <Typography variant="body2" color="textSecondary">
                Fecha de Emisión: {factura.fecha_emision}
              </Typography>
            </Grid>
            <Grid item xs={12} md={6} sx={{ textAlign: { md: 'right' } }}>
              <Typography variant="h4" sx={{ 
                color: colorPrincipal, 
                fontWeight: 'bold',
                // textDecoration: isAnulada ? 'line-through' : 'none'
              }}>
                ${factura.importe_total.toLocaleString()}
              </Typography>
              <Typography variant="body2" color="textSecondary">
                CAE: {factura.cae}
              </Typography>
              <Typography variant="body2" color="textSecondary">
                Vencimiento CAE: {factura.vencimiento_cae}
              </Typography>
            </Grid>
          </Grid>
        </Paper>

        {/* Sección de cliente y factura */}
        <Grid container spacing={3}>
          {/* Datos del cliente */}
          <Grid item xs={12} md={6}>
            <Paper sx={{ 
              p: 3, 
              borderRadius: 2, 
              boxShadow: 2, 
              height: '90%',
              borderTop: `3px solid ${colorPrincipal}`
            }}>
              <Typography variant="h6" gutterBottom sx={{ 
                color: colorPrincipal, 
                borderBottom: `2px solid ${colorPrincipal}`, 
                pb: 1,
                display: 'flex',
                alignItems: 'center'
              }}>
                <Box sx={{
                  width: '8px',
                  height: '24px',
                  bgcolor: colorPrincipal,
                  mr: 1,
                  borderRadius: '2px'
                }}/>
                Datos del Cliente
              </Typography>
              
              <Box sx={{ mt: 2 }}>
                <Typography variant="subtitle2" sx={{ fontWeight: 'bold', color: colorPrincipal }}>Razón Social</Typography>
                <Typography paragraph>{factura.razon_social}</Typography>
                
                <Typography variant="subtitle2" sx={{ fontWeight: 'bold', color: colorPrincipal }}>CUIT</Typography>
                <Typography paragraph>{factura.cuit}</Typography>
                
                <Typography variant="subtitle2" sx={{ fontWeight: 'bold', color: colorPrincipal }}>Condición IVA</Typography>
                <Typography paragraph>{factura.condicion_iva}</Typography>
                
                <Typography variant="subtitle2" sx={{ fontWeight: 'bold', color: colorPrincipal }}>Condición de Pago</Typography>
                <Typography paragraph>{factura.condicion_pago}</Typography>
                
                <Typography variant="subtitle2" sx={{ fontWeight: 'bold', color: colorPrincipal }}>Domicilio</Typography>
                <Typography>{factura.domicilio}</Typography>
              </Box>
            </Paper>
          </Grid>

          {/* Datos de la factura */}
          <Grid item xs={12} md={6}>
            <Paper sx={{ 
              p: 3, 
              borderRadius: 2, 
              boxShadow: 2, 
              height: '90%',
              borderTop: `3px solid ${colorPrincipal}`
            }}>
              <Typography variant="h6" gutterBottom sx={{ 
                color: colorPrincipal, 
                borderBottom: `2px solid ${colorPrincipal}`, 
                pb: 1,
                display: 'flex',
                alignItems: 'center'
              }}>
                <Box sx={{
                  width: '8px',
                  height: '24px',
                  bgcolor: colorPrincipal,
                  mr: 1,
                  borderRadius: '2px'
                }}/>
                Detalles de {isAnulada ? "Factura Anulada" : "Facturación"} {factura.a_consfinal===1?"- (Facturado a Consumidor Final)":""}
              </Typography>
              
              <Grid container spacing={2} sx={{ mt: 1 }}>
                <Grid item xs={4}>
                  <Typography variant="subtitle2" sx={{ fontWeight: 'bold', color: colorPrincipal }}>Número</Typography>
                  <Typography>{factura.nro_comprobante}</Typography>
                </Grid>
                <Grid item xs={4}>
                  <Typography variant="subtitle2" sx={{ fontWeight: 'bold', color: colorPrincipal }}>Fecha</Typography>
                  <Typography>{factura.fecha_emision}</Typography>
                </Grid>
                <Grid item xs={4}>
                  <Typography variant="subtitle2" sx={{ fontWeight: 'bold', color: colorPrincipal }}>Medio Pago</Typography>
                  {factura.medios_pago_combinados.split(' - ').map((medio, index) => (
                    <Typography key={index}>• {medio}</Typography>
                  ))}
                </Grid>
              </Grid>
              
              <Divider sx={{ my: 2, borderColor: colorPrincipal, opacity: 0.3 }} />
              
              <Typography variant="h6" gutterBottom sx={{ color: colorPrincipal }}>
                Importes
              </Typography>
              
              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <Typography variant="subtitle2" sx={{ fontWeight: 'bold', color: colorPrincipal }}>Importe Neto</Typography>
                  <Typography >
                    ${factura.importe_neto.toLocaleString()}
                  </Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography variant="subtitle2" sx={{ fontWeight: 'bold', color: colorPrincipal }}>IVA</Typography>
                  <Typography >
                    ${factura.importe_iva.toLocaleString()}
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <Box sx={{ 
                    backgroundColor: colorSecundario,
                    p: 2, 
                    borderRadius: 1,
                    mt: 1,
                    border: `1px solid ${colorPrincipal}`
                  }}>
                    <Grid container>
                      <Grid item xs={6}>
                        <Typography variant="subtitle1" sx={{ fontWeight: 'bold', color: colorPrincipal }}>
                          {isAnulada ? "Total Anulado" : "Total"}
                        </Typography>
                      </Grid>
                      <Grid item xs={6} sx={{ textAlign: 'right' }}>
                        <Typography variant="subtitle1" sx={{ 
                          fontWeight: 'bold', 
                          color: colorPrincipal,
                          // textDecoration: isAnulada ? 'line-through' : 'none'
                        }}>
                          ${factura.importe_total.toLocaleString()}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Box>
                </Grid>
              </Grid>
            </Paper>
          </Grid>
        </Grid>

        {/* Productos */}
        <Paper sx={{ 
          p: 3, 
          borderRadius: 2, 
          boxShadow: 2, 
          mt: 3,
          borderTop: `3px solid ${colorPrincipal}`
        }}>
          <Typography variant="h6" gutterBottom sx={{ 
            color: colorPrincipal, 
            borderBottom: `2px solid ${colorPrincipal}`, 
            pb: 1,
            display: 'flex',
            alignItems: 'center'
          }}>
            <Box sx={{
              width: '8px',
              height: '24px',
              bgcolor: colorPrincipal,
              mr: 1,
              borderRadius: '2px'
            }}/>
            Detalle de Productos {isAnulada && "(Anulados)"}
          </Typography>
          
          <Box sx={{ 
            backgroundColor: colorSecundario, 
            p: 2, 
            borderRadius: 1,
            mt: 2,
            border: `1px solid ${isAnulada ? "#EF9A9A" : "#e0e0e0"}`
          }}>
            {productos.map((p,i) => (
              <Box key={i} sx={{ mb: i < productos.length - 1 ? 2 : 0 }}>
                <Typography variant="body1" component="pre" sx={{ 
                  fontFamily: 'monospace',
                  whiteSpace: 'pre-wrap',
                  wordWrap: 'break-word',
                  margin: 0,
                  color: isAnulada ? '#5D4037' : '#2C3E50'
                }}>
                  {p}
                </Typography>
                {i < productos.length - 1 && (
                  <Divider sx={{ 
                    my: 1, 
                    borderColor: colorPrincipal, 
                    opacity: 0.2 
                  }} />
                )}
              </Box>
            ))}
          </Box>
        </Paper>
      </Box>
    </Box>
  );
}

export default VerFacturaEnvasado;